import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import SEOHead from './components/SEOHead';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ProjectsPage from './pages/ProjectsPage';

// Component to enforce trailing slashes
const TrailingSlashRedirect = () => {
  const location = useLocation();
  // If path doesn't end with / and isn't the root, redirect
  if (location.pathname !== '/' && !location.pathname.endsWith('/')) {
    return <Navigate to={`${location.pathname}/${location.search}${location.hash}`} replace />;
  }
  return null;
};

function AppContent() {
  return (
    <LanguageProvider>
      <SEOHead />
      <TrailingSlashRedirect />
      <div className="min-h-screen bg-[#0d1117]">
        <Navbar />
        <Routes>
          {/* English routes — with and without trailing slash */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about/" element={<AboutPage />} />
          <Route path="/services/" element={<ServicesPage />} />
          <Route path="/projects/" element={<ProjectsPage />} />
          {/* Slovenian routes */}
          <Route path="/sl/" element={<HomePage />} />
          <Route path="/sl/o-nas/" element={<AboutPage />} />
          <Route path="/sl/storitve/" element={<ServicesPage />} />
          <Route path="/sl/projekti/" element={<ProjectsPage />} />
        </Routes>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
